/*
 * Copyright (c) Nexign, JSC, 2020-2022.
 */
/**
 * Actions for Calls Detail
 *
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.4.0
 */

import { createAction } from '../../modules/app/createAction';
import { TWizardStorageClearStepsAction } from '../../modules/wizard/wizardTypes';
import {
    CALLS_DETAIL_HANDLE_NEXT,
    CALLS_DETAIL_SET_IS_STEP_VALID,
    CALLS_DETAIL_SET_PARAMS,
    CALLS_DETAIL_STORAGE_SAVE,
    CALLS_DETAIL_VALIDATE_START,
} from './callsDetailConstants';
import {
    ICallsDetailSetIsStepValidPayload,
    ICallsDetailSetParamsPayload,
    TCallsDetailSetIsStepValidAction,
    TCallsDetailSetParamsAction,
    TCallsDetailStorageSaveAction,
    TCallsDetailValidateStartAction,
} from './callsDetailTypes';


export const callsDetailValidateStart = (): TCallsDetailValidateStartAction =>
    createAction(CALLS_DETAIL_VALIDATE_START);

export const callsDetailSetIsStepValid = (payload: ICallsDetailSetIsStepValidPayload):
    TCallsDetailSetIsStepValidAction => createAction(CALLS_DETAIL_SET_IS_STEP_VALID, payload);


export const callsDetailStorageSave = (): TCallsDetailStorageSaveAction => createAction(CALLS_DETAIL_STORAGE_SAVE);

export const callsDetailSetParams = (payload: ICallsDetailSetParamsPayload):
    TCallsDetailSetParamsAction => createAction(CALLS_DETAIL_SET_PARAMS, payload);

export const callsDetailHandleNext = () => createAction(CALLS_DETAIL_HANDLE_NEXT);

export type TCallsDetailActions = TCallsDetailValidateStartAction
    | TCallsDetailSetIsStepValidAction
    | TCallsDetailSetParamsAction
    | TCallsDetailStorageSaveAction
    | TWizardStorageClearStepsAction
    ;
